var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"app",attrs:{"id":"app"}},[_c('container',{attrs:{"toolRouteIsActive":_vm.routeIsTool}},[_c('router-view'),(!_vm.routeIsTool)?_c('chat-bot',{attrs:{"iconStyle":_vm.chatbotStyle}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }